import { debounce, uniq } from 'lodash';
import React, { createRef } from 'react';
import { withTranslation } from 'react-i18next';
import { UserItemRenderer } from '@workboard/ui-search';
import GoalServices from '../../../../services/goal.services';

export default withTranslation()(class MetricOwnerComp extends React.Component {
  constructor(props) {
    super(props)
    this.state = {
      krOwnerEn: false,
      ownerSearchVal: '',
      userId: props.item.id,
      userPic: props.item.avatar,
      userText: props.item.name,
      mitChildKr: props.mitChildKr,
      ownerList: [],
      offset: 5,
      limit: 5
    }
    this.GoalServices = new GoalServices()
    this.changeSearchBox = this.changeSearchBox.bind(this)
    this.changeSourceVal = this.changeSourceVal.bind(this)
    this.updateOwnerList = this.updateOwnerList.bind(this)
    this.handleOwnerSelect = this.handleOwnerSelect.bind(this)
    this.filterOwnerFunction = this.filterOwnerFunction.bind(this)
    this.selectedRef = createRef()
    this.handleClickOutside = this.handleClickOutside.bind(this)
    this.delayedCalleback = debounce(function (event) {
      let _this = this
      this.setState({ ownerSearchVal: event.target.value }, () =>
        _this.filterOwnerFunction(event)
      )
    }, 300)
    this.observer = createRef(null);
  }
  componentDidMount() {
    document.addEventListener('mousedown', this.handleClickOutside)
    //$(".goalPopupNew").css("overflow", "hidden");
    // if (this.state.source != 1) {
    // 	let changeDefaultOwner = {
    // 		fullName: this.props.goalDetails.owner_fullname,
    // 		userId: this.props.goalDetails.owner_id,
    // 		picture: this.props.goalDetails.owner_pic,
    // 		counting: 1
    // 	};
    // 	this.changeSourceVal(changeDefaultOwner);
  }

  componentWillUnmount() {
    document.removeEventListener('mousedown', this.handleClickOutside)
  }

  fetchData(node){
    let _this = this;
    if (this.observer.current) this.observer.current.disconnect()
    this.observer.current = new IntersectionObserver(entries => {
      if (entries[0].isIntersecting) {
        if(_this.state.limit === 5 && (!_this.state.ownerSearchVal ||  _this.state.ownerSearchVal.length <= 0 )){
          this.GoalServices.getTeamAndOrgUsersList({
            term: '',
            offset: _this.state.offset,
            limit: _this.state.limit,
            teamId: _this.props.teamId,
            excludeAIAgents: true
          }).then(function (response) {
            if (response.data) {
              let owner = [..._this.state.ownerList, ...response.data.data];
              _this.setState({
                ownerList: uniq(owner,'userId'),
                offset: _this.state.offset + 5,
                limit: response.data.data.length
               })
            }
          })
        }
      }
    })
    if (node) this.observer.current.observe(node)
  }

  fetchDataProp = this.fetchData.bind(this);

  handleClickOutside(event) {
    if (this.selectedRef && !this.selectedRef.current.contains(event.target)) {
      this.setState({ krOwnerEn: false })
    }
  }

  changeSearchBox(event) {
    event.persist()
    this.delayedCalleback(event)
  }

  changeSourceVal(val) {
    this.setState({
      userText: val.fullName,
      userId: val.userId,
      UserPic: val.picture,
      dsMetric: val.counting,
    })
  }

  updateOwnerList(list){
    this.setState({
      ownerList: list,
      limit: list.length
    })
  }

  handleOwnerSelect(val) {
    let data = {
      userText: val.fullName,
      userId: val.userId,
      userPic: val.picture,
    }
    this.setState(
      {
        // ownerText: val.fullName,
        // owner: val.userId,
        // krOwnerPic: val.picture,
        ...data,
        krOwnerEn: false,
      },
      () => {
        if (this.props.updateData) {
          this.props.updateData(data)
        }
      }
    )
    setTimeout(() => {
      document.getElementById(this.props.addId).focus();
    });
  }
  filterOwnerFunction(event) {
    let input, filter
    let _this = this
    input = document.getElementById('krOwnerSearch')
    filter = input?.value.toLowerCase() || ''
    filter = filter[0] === ' ' ? filter[0].replace(' ', '') : filter
    filter =
      filter[filter.length - 1] === ' '
        ? filter[filter.length - 1].replace(' ', '')
        : filter
    if (filter.length > -1) {
      this.GoalServices.getTeamAndOrgUsersList({
        term: filter,
        teamId: _this.props.teamId,
        excludeAIAgents: true
      }).then(function (response) {
        if (response.data) {
          let list = response.data.data;
          if (_this.props.coOwners && _this.props.coOwners.length) {
            let coOwnerIds = _this.props.coOwners.map(x => x.id);
            list = list.filter(x => !coOwnerIds.includes(x.userId))
          }
          _this.updateOwnerList(list)
          // if (response.data.data.length > 0 && _this.state.ownerSearchVal.length > 1) {
          //     $(".metricOwnerSec").parent().animate({ scrollTop: 300 });
          // }
          if (_this.props.scrollElClass) {
            //$('.krRightPaneContent').parent().animate({ scrollTop: 530 });
            // if(_this.props.scrollElClass == "goalPopupNew"){
            //     let goalPopupEl = $(`.${_this.props.scrollElClass}`);
            //     goalPopupEl.find(".kREmptyArea").css("margin-bottom", "63px");
            //     goalPopupEl.animate({ scrollTop: 530 });
            // }else{
            const offsetEl = document.querySelector('.addOkrContent')
            const scrollTop =
              offsetEl && offsetEl.offsetHeight > 900
                ? offsetEl.offsetHeight - 400
                : 500
            $(`.${_this.props.scrollElClass}`).animate(
              { scrollTop },
              100
            )
            //}
          }
        }
      })
    } else {
      _this.setState({
        ownerList: [],
      })
    }
  }
  render() {
    const { t } = this.props
    return (
      <div
        className="metricOwnerSec"
        style={{ position: 'relative', display: 'inline' }}
        ref={this.selectedRef}
        onClick = {(event) => {this.setState({limit : 5, offset : 5}); this.changeSearchBox(event);}}
      >
        <div
          className="verticalTop ownerKrName inLineBlk truncate"
          onClick={(event) => {
            this.setState({ krOwnerEn: !this.state.krOwnerEn, ownerList: [] })
          }}
          onKeyDown={(e) => {
            if (e.keyCode === 13 || e.keyCode === 32) {
              this.setState({ krOwnerEn: !this.state.krOwnerEn, ownerList: [] })
            }
          }}
          tabIndex={0}
          id={this.props.addId}
        >
          <img src={this.state.userPic} className="fitProfileImage" alt="" />
          <div
            className="person-owner-text-arrow truncate"
            data-testid="person-owner-text-arrow truncate"
          >
            {this.state.userText}
          </div>
          {!this.state.mitChildKr && <div className="arrowDown " />}
        </div>
        {this.state.krOwnerEn && !this.state.mitChildKr && (
          <div
            id="myAlign"
            data-testid="myAlign"
            className="myownerAlign dropdown-krcontent"
          >
            <input
              type="text"
              placeholder={t("Search for people")}
              id="krOwnerSearch"
              role="search"
              className="aEOwnerSearch"
              onChange={(event) => this.changeSearchBox(event)}
              autoFocus={true}
              aria-labelledby={this.props.metric_id || null}
            />
            <div className="myownerList" role="listbox">
              {this.state.ownerList &&
                this.state.ownerList.map((val, index) => (this.state.ownerList.length === index + 1 ?
                  <div
                    key={val.userId}
                    role="option"
                    aria-selected={String(val.userId) === String(this.state.userId)}
                    tabIndex={0}
                    ref={this.fetchDataProp}
                    className="ownerSecic"
                    onClick={() => {
                      this.handleOwnerSelect(val)
                    }}
                    onKeyDown={(e) => {
                      if (e.keyCode === 13 || e.keyCode === 32) {
                        e.preventDefault()
                        this.handleOwnerSelect(val)
                      }
                    }}
                  >
                    <UserItemRenderer option={val} />
                  </div> :
                  <div
                  key={val.userId}
                  role="option"
                  aria-selected={String(val.userId) === String(this.state.userId)}
                  tabIndex={0}
                  className="ownerSecic"
                  onClick={() => {
                    this.handleOwnerSelect(val)
                  }}
                  onKeyDown={(e) => {
                    if (e.keyCode === 13 || e.keyCode === 32) {
                      e.preventDefault()
                      this.handleOwnerSelect(val)
                    }
                  }}
                >
                  <UserItemRenderer option={val} />
                </div>
                  )

                )}
            </div>
          </div>
        )}
      </div>
    )
  }
})
